import type {
  IFileUploadEntry,
  IUploadAudioFileParams,
} from "@frontend-shared/types";
import { createContext } from "react";

export interface IMeetingUploadContext {
  // NOTE: Every upload the user has started in this authenticated session,
  // oldest first. Lives above the routes so an in-flight upload — and its
  // progress, error, and success rows — survives the Uploads page unmounting
  // when the user navigates to an already-processed meeting (NSAI-5141).
  uploads: IFileUploadEntry[];
  // NOTE: NSAI-5560 — returns whether the upload actually started. It does not
  // when the very same file is already uploading: a second copy would transfer
  // in full only to be refused by the server's content-hash check, so the
  // uploader turns it away up front (and says so). Callers that report a queued
  // file — the integration picker — must not treat a refusal as started.
  uploadFile: (props: IUploadAudioFileParams) => boolean;
  cancelUpload: (uploadId: string) => void;
  removeUpload: (uploadId: string) => void;
}

export const MeetingUploadContext = createContext<IMeetingUploadContext | null>(
  null,
);
